import PropTypes from 'prop-types';
import OrganizationPropType from './organization';

export default PropTypes.shape({
  data: OrganizationPropType.isRequired,
  redirect: PropTypes.func.isRequired,
  label: PropTypes.string
});
